<div class="blade-wrapper">
  <div class="blade-header">
    <div  class="blade-tools">
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized ">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-mobile_home"
                     *ngIf="!fieldsets.mobile_home.hidden && !fieldsets.mobile_home.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.mobile_home.collapsible }">
                    <div *ngIf="!fieldsets.mobile_home.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.mobile_home.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.mobile_home.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.mobile_home.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.mobile_home.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.mobile_home.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.mobile_home.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-tote_induction" *ngIf="!fields.tote_induction.hidden && !fields.tote_induction.removed" 
                            class="field-container standard {{fields.tote_induction.invalid ? 'invalid' : ''}} {{fields.tote_induction.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.tote_induction.styles.style"
                            [ngClass]="fields.tote_induction.styles.classes">
                        <div *ngIf="fields.tote_induction.label" class="label-container"
                             [matTooltip]="fields.tote_induction.tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.tote_induction.label}}<span *ngIf="fields.tote_induction.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <button mat-button
                                data-cy="button"
                                class="datex-button"
                                [disabled]="fields.tote_induction.control.readOnly || fields.tote_induction.control.disabled"
                                [ngStyle]="fields.tote_induction.control.styles.style"
                                [ngClass]="fields.tote_induction.control.styles.classes"
                                [matTooltip]="fields.tote_induction.control.tooltip"
                                (click)="on_tote_induction_button_clicked($event)"
                                >
                          <div class="button-label">
                            <ng-container *ngIf="fields.tote_induction.control.icon === 'datex-default-spinner'; else showIcon">
                              <div class="button-icon">
                                <i data-cy="button-icon" class="datex-default-spinner"></i>
                              </div>
                            </ng-container>
                            <ng-template #showIcon>
                              <div class="button-icon">
                                <i data-cy="button-icon" class="icon {{fields.tote_induction.control.icon}}"></i>
                              </div>
                            </ng-template>
                            <div data-cy="button-label" class="button-text">{{fields.tote_induction.control.label}}</div>
                          </div>
                        
                        </button>
                        <ng-container *ngIf="fields.tote_induction.invalid">
                          <ng-container *ngFor="let error of fields.tote_induction.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-tote_picking" *ngIf="!fields.tote_picking.hidden && !fields.tote_picking.removed" 
                            class="field-container standard {{fields.tote_picking.invalid ? 'invalid' : ''}} {{fields.tote_picking.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.tote_picking.styles.style"
                            [ngClass]="fields.tote_picking.styles.classes">
                        <div *ngIf="fields.tote_picking.label" class="label-container"
                             [matTooltip]="fields.tote_picking.tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.tote_picking.label}}<span *ngIf="fields.tote_picking.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <button mat-button
                                data-cy="button"
                                class="datex-button"
                                [disabled]="fields.tote_picking.control.readOnly || fields.tote_picking.control.disabled"
                                [ngStyle]="fields.tote_picking.control.styles.style"
                                [ngClass]="fields.tote_picking.control.styles.classes"
                                [matTooltip]="fields.tote_picking.control.tooltip"
                                (click)="on_tote_picking_button_clicked($event)"
                                >
                          <div class="button-label">
                            <ng-container *ngIf="fields.tote_picking.control.icon === 'datex-default-spinner'; else showIcon">
                              <div class="button-icon">
                                <i data-cy="button-icon" class="datex-default-spinner"></i>
                              </div>
                            </ng-container>
                            <ng-template #showIcon>
                              <div class="button-icon">
                                <i data-cy="button-icon" class="icon {{fields.tote_picking.control.icon}}"></i>
                              </div>
                            </ng-template>
                            <div data-cy="button-label" class="button-text">{{fields.tote_picking.control.label}}</div>
                          </div>
                        
                        </button>
                        <ng-container *ngIf="fields.tote_picking.invalid">
                          <ng-container *ngFor="let error of fields.tote_picking.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.mobile_home.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

    </div>
  </div>
</div>